import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { loadBlogPosts } from '../blog';
import { LayoutContext } from '../types/translations';
import { BlogPost } from '../types/content';
import Filters from '../components/filter';

const Blog: React.FC = () => {
  const { language, texts } = useOutletContext<LayoutContext>();
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [filteredPosts, setFilteredPosts] = useState<BlogPost[]>([]);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const posts = await loadBlogPosts(language);
        setBlogPosts(posts);
        setFilteredPosts(posts);
      } catch (error) {
        console.error('Error loading blog posts:', error);
        setBlogPosts([]);
        setFilteredPosts([]);
      }
    };

    loadPosts();
  }, [language]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#1a1a1a] text-gray-900 dark:text-white transition-colors duration-200">
      <main className="container mx-auto px-6 pt-32">
        <h1 className="text-4xl font-bold mb-4">{texts.blog.title}</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-8">{texts.blog.intro}</p>
        <Filters items={blogPosts} onFilteredItemsChange={setFilteredPosts} placeholderText="Search articles..." />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {filteredPosts.map((post, index) => (
            <Link to={`/blog/${index}`} key={index} className="block">
              <article className="flex items-center bg-white dark:bg-gray-800 rounded-lg p-6 shadow-lg hover:shadow-xl dark:hover:bg-gray-800/50 transition-shadow">
                <div className="flex-1">
                  <p className="text-sm text-gray-500 dark:text-gray-400">{post.date}</p>
                  <h2 className="text-2xl font-bold mb-4">{post.title}</h2>
                  <p className="text-gray-600 dark:text-gray-300">{post.preview}</p>
                </div>
                {post.icon && (<img src={post.icon} alt={post.title} className="w-20 h-20 rounded-lg object-cover ml-6" />)}
              </article>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Blog;
